<template>
  <div class="flex_column_evenly pair">
    <div class="flex_row_center">
      <i class="incfont el-icon-title"></i>
      <span lang="PairTool" class="margin_left">配对工具</span>
    </div>
    <el-button @click="handleRecorderClick" class="pair_button"><span lang="Pair">配对</span></el-button>
  </div> 
</template>

<script>
  import Recorder from '@/assets/js/recorder-core'

  export default {
    data() {
      return {
        rec:{},
        lowPcmCnt:0,
        sampleBuf:new Int16Array(),
      }
    },
    methods: {
      handleRecorderClick() {
          this.rec.open( function(){
            this.rec.start();
            console.log("开始");
            }
        );
      },
      recProcess(buffer, powerLevel, bufferDuration, bufferSampleRate,newBufferIdx,asyncEnd) {
        var data_48k = buffer[buffer.length-1];  

        // console.log('pcm level: ' + powerLevel);
        if (this.lowPcmCnt > 15 && powerLevel < 5) {
            this.lowPcmCnt ++;
            return;
        } else if (powerLevel > 20) {
            this.lowPcmCnt = 0;
        } else {
            this.lowPcmCnt ++;
        }
 
        var  array_48k = new Array(data_48k);
        var data_16k=Recorder.SampleData(array_48k,bufferSampleRate,16000).data;
 
        this.sampleBuf = Int16Array.from([...sampleBuf, ...data_16k]);
        var chunk_size=960; // for asr chunk_size [5, 10, 5]
        info_div.innerHTML=""+bufferDuration/1000+"s";
        while(this.sampleBuf.length>=chunk_size){
            var sendBuf=this.sampleBuf.slice(0,chunk_size);
            this.sampleBuf=sampleBuf.slice(chunk_size,this.sampleBuf.length);
            console.log("sendbuf:",sendBuf);
        }
      },
    },
    watch: {

    },
    created() {
      this.rec = Recorder({
          type:"pcm",
          bitRate:16,
          sampleRate:16000,
          onProcess:this.recProcess
      });
    },
    beforeDestroy() {

    }
  }
</script>

<style lang="less" scoped>

</style>